module.exports = __webpack_public_path__ + "static/media/home-category-6.dc8fc4af.png";